import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchTemplateVersions } from '../services/documentTemplates';
import { documentTemplateKeys } from './documentTemplateKeys';

export const useTemplateVersionsQuery = (templateId: string, page: number, perPage: number) =>
  useQuery({
    queryKey: [...documentTemplateKeys.versionPage(templateId, page), perPage],
    queryFn: () => fetchTemplateVersions(templateId, page, perPage),
    placeholderData: keepPreviousData,
  });
